// Helpers for formatting relative dates.
import { translateLabel } from "./translation";
import { t } from "util/stdtypes";

export function formatDate(date, language = 'english') {
    const currentDate = new Date();
    const inputDate = new Date(date);
    const locale = getLocale(language);

    if (isNaN(inputDate.getTime())) {
        return '';
    }

    const diffInSeconds = Math.floor((currentDate.getTime() - inputDate.getTime()) / 1000);


    if (diffInSeconds < 60) {
        return translateLabel({label: t('Just now'), language});
    } else if (diffInSeconds < 3600) {
        const minutes = Math.floor(diffInSeconds / 60);
        if (minutes == 1) {
            return translateLabel({label: t('1 minute ago'), language});
        } else {
            return translateLabel({label: t('{minutes} minutes ago'), language, formatParams:{minutes}});
        }
    } else if (diffInSeconds < 86400) {
        const hours = Math.floor(diffInSeconds / 3600);
        if (hours == 1) {
            return translateLabel({label: t('1 hour ago'), language});
        } else {
            return translateLabel({label: t('{hours} hours ago'), language, formatParams:{hours}});
        }
    } else if (diffInSeconds < 2592000) {
        const days = Math.floor(diffInSeconds / 86400);
        if (days == 1) {
            return translateLabel({label: t('1 day ago'), language});
        } else {
            return translateLabel({label: t('{days} days ago'), language, formatParams:{days}});
        }
    } else if (currentDate.getFullYear() == inputDate.getFullYear()) {
        const formattedDate = inputDate.toLocaleDateString(locale, {
            month: 'short',
            day: 'numeric',
        });
        return formattedDate;
    } else {
        const formattedDate = inputDate.toLocaleDateString(locale, {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
        });
        return formattedDate;
    }
}

export function formatMiniDate(date, language = 'english') {
    const currentDate = new Date();
    const inputDate = new Date(date);

    if (isNaN(inputDate.getTime())) {
        return '';
    }

    const diffInSeconds = Math.floor((currentDate.getTime() - inputDate.getTime()) / 1000);

    if (diffInSeconds < 60) {
        return translateLabel({label: t('now'), language});
    } else if (diffInSeconds < 3600) {
        const minutes = Math.floor(diffInSeconds / 60);
        return translateLabel({label: t('{minutes}m'), language, formatParams:{minutes}});
    } else if (diffInSeconds < 86400) {
        const hours = Math.floor(diffInSeconds / 3600);
        return translateLabel({label: t('{hours}h'), language, formatParams:{hours}});
    } else if (diffInSeconds < 31536000) {
        const days = Math.floor(diffInSeconds / 86400);
        return translateLabel({label: t('{days}d'), language, formatParams:{days}});
    } else {
        const years = Math.floor(diffInSeconds / 31536000);
        return translateLabel({label: t('{years}y'), language, formatParams:{years}});
    }
}

export function getLocale(language = 'english') {
    switch (language) {
    case 'english':
        return "en-US";
    case 'german':
        return "de-DE";
    case 'french_canadian':
        return "fr-CA";
    case 'french':
        return "fr-FR";
    default:
        return "en-US";
    }
}